<style scoped></style>

<template>
    <button
        class="btn p-0 relative max-w-full text-sm focus:outline-none"
        :class="[btnBorder, btnBg]"
        @click="addToCart"
    >
        <div
            class="flex flex-row items-center justify-center w-full bg-secondary py-1 px-2 lg:px-3 text-white"
            :class="{ invisible: status === 'showAdded' }"
        >
            <div class="icon ">
                <shoppingCartSvg />
            </div>

            <div class="pl-1 lg:pl-2 text-center">
                {{ $t('cart.add') }}
            </div>
        </div>
        <div
            class="flex items-center bg-gray-100 absolute inset-0 justify-center"
            v-if="status === 'loading'"
        >
            <spinner class="spinner-sm" />
        </div>
        <div
            class="flex items-center bg-primary text-white absolute inset-0 justify-center"
            v-if="status === 'showAdded'"
        >
            {{ $t('cart.add.success') }}
        </div>
        <div
            class="flex items-center bg-red text-white absolute inset-0 justify-center"
            v-else-if="status === 'showAddFail'"
        >
            {{ $t('cart.add.fail') }}
        </div>
        <div
            class="flex items-center bg-red text-white absolute inset-0 justify-center"
            v-else-if="status === 'showExcessMaxQty'"
        >
            {{ $t('cart.add.fail.excess.max.qty') }}
        </div>
    </button>
</template>

<script>
import shoppingCartSvg from '@/assets/svg/shopping_cart.svg';
import spinner from '@/components/spinner.vue';
import { marketingEventHandler } from '../utils/marketingDataProcessor.js';

export default {
    components: { shoppingCartSvg, spinner },
    props: {
        product: { required: true },
        quantity: { default: 1 }
    },
    data() {
        return { status: undefined };
    },
    computed: {
        productCartQty() {
            const p = this.$store.state.cartItems.find(
                c => c.shopListProdKey === this.product.id
            );
            return p ? p.prodOrdQty : 0;
        },
        maxOrdQtyPerPerson() {
            return this.$store.getters.getProductMaxOrdQtyPerPerson(
                this.product
            );
        },
        productActualRemainingQty() {
            return this.$store.getters.productActualRemainingQty(this.product);
        },
        btnBorder() {
            const status = this.status;
            if (status === 'showAddFail' || status === 'showExcessMaxQty') {
                return 'border-red';
            }
            if (status === 'showAdded') {
                return 'border-primary';
            }
            if (status === 'loading') {
                return 'border-gray-100';
            }
            return 'border-secondary';
        },
        btnBg() {
            const status = this.status;
            if (status === 'showAddFail' || status === 'showExcessMaxQty') {
                return 'bg-red';
            }
            if (status === 'showAdded') {
                return 'bg-primary';
            }
            if (status === 'loading') {
                return 'bg-gray-100';
            }
            return '';
        },
        isPreviewShoppingListByShopListKey() {
            return this.$store.getters.isPreviewShoppingListByShopListKey;
        }
    },
    methods: {
        async addToCart() {
            if (this.isPreviewShoppingListByShopListKey) {
                return;
            }

            if (this.status !== undefined) {
                return;
            }

            if (!this.$store.state.user) {
                this.$store.commit('setShowLoginRegisterModal', true);
                return;
            }

            // Capture when customer click 'Add to Cart', no matter success or not
            marketingEventHandler.addToCartClick(
                this.product.prodKey,
                this.product.shopListKey
            );

            let quantity = this.quantity;
            if (
                quantity + this.productCartQty > this.maxOrdQtyPerPerson ||
                quantity + this.productCartQty > this.productActualRemainingQty
            ) {
                this.status = 'showExcessMaxQty';
            } else {
                this.status = 'loading';
                let result = await this.$store.dispatch('setCartProduct', {
                    shopListProdKey: this.product.id,
                    prodOrdQty: quantity,
                    isAdd: true
                });
                this.status =
                    result && result.success ? 'showAdded' : 'showAddFail';
            }
            // await new Promise(rs => setTimeout(rs, 500));
            setTimeout(() => (this.status = undefined), 800);
        }
    }
};
</script>
